import { Cart } from '@/models/cart/cart'
import { CartItem } from '@/models/cart/cart-item'

/**
 * 「カート」というコンテクストに於いて、商品を取り扱う際のルールを記述する.
 * 「親商品と子商品は同じ処理を行う」
 * 「〜な商品に対しては、xxxという前処理をかけてから本処理を行う」
 * といった、
 * カートで商品を取り扱う際に明示すべき仕様はこのIFを実装する形で定義する.
 */
export interface DealWithItemViaCartSpec {
  apply(command: Command): Command
}

export type Command = (item: CartItem, cart: Cart) => Promise<CommandResult>

export interface CommandResult {
  readonly success: boolean
  readonly failed: boolean

  readonly errors: Error[]

  readonly processed: CartItem[]

  and(other: CommandResult): CommandResult
}
export class CommandResultContainer implements CommandResult {
  static empty(): CommandResultContainer {
    return new CommandResultContainer([], [])
  }
  static createAsSuccess(successed: CartItem): CommandResultContainer {
    return new CommandResultContainer([successed], [])
  }
  static createAsFail(errors: Error[]): CommandResultContainer {
    return new CommandResultContainer([], errors)
  }

  private constructor(readonly processed: CartItem[], readonly errors: Error[]) { }

  get success(): boolean {
    return this.errors.length === 0
  }
  get failed(): boolean {
    return !this.success
  }

  and(other: CommandResult): CommandResult {
    return new AndCommandResult(this, other)
  }
}

class AndCommandResult implements CommandResult {
  constructor(
    private readonly a: CommandResult,
    private readonly b: CommandResult
  ) { }

  get success(): boolean {
    return this.a.success && this.b.success
  }
  get failed(): boolean {
    return !this.success
  }

  get errors(): Error[] {
    return [...this.a.errors, ...this.b.errors]
  }

  get processed(): CartItem[] {
    return [...this.a.processed, ...this.b.processed]
  }

  and(other: CommandResult): CommandResult {
    return new AndCommandResult(this, other)
  }
}
